import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { DefaultmeetingService } from 'src/app/services/defaultmeeting.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-default-meeting-list',
  templateUrl: './default-meeting-list.component.html',
  styleUrls: ['./default-meeting-list.component.css']
})
export class DefaultMeetingListComponent implements OnInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  defaultMeetingMasterData: any[];
  dftMeetingId:any;
  dataAvailable:boolean;

  constructor(
    private defaultmeetingService: DefaultmeetingService,
    private router:Router,
    private alert:AlertComponent,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.getDefaultMeetingMasterList();
    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [{
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Default Meeting Details Master List',
          title: 'Default Meeting Details Master List',
          extend: 'excel',
          exportOptions: {
            columns: [0],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }
        }]
    };

  }
  showAddPopUp(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['defaultMeeting', 'add']  } }],
      { relativeTo: this.route.parent });
  }
  getDefaultMeetingMasterList() {
    this.defaultMeetingMasterData = [];
    this.defaultmeetingService.getDefaultMeetingList()
      .subscribe(dataList => {
        if (dataList.status == 0) {
          this.dataAvailable=true;
          this.defaultMeetingMasterData = dataList.defaultMeetingDataList;
          this.dtTrigger.next();
        }else{
          this.dataAvailable=false;
          this.dtTrigger.next();
        }
         
      })
  }

  editDefaultMeetingMaster(deftMeetingId)
  {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['defaultMeeting', 'edit',deftMeetingId]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['defaultMeeting/edit', deftMeetingId]);
  }

  deleteConfirmation(dftMeetingId) {
    this.dftMeetingId = dftMeetingId;
    $('#confirmation').modal('toggle');
  }

  deleteDefaultMeetingMaster() {
    if(this.dftMeetingId!=undefined && this.dftMeetingId!="")
    {
      this.defaultmeetingService.deleteDefaultMeetingMasterData(this.dftMeetingId).subscribe(data => {
        if (data.status == 0) {
          $('#deleteMeetingConfirmation').modal('toggle');
          this.alert.success(data.message);
        }
        if (this.dtElement.dtInstance != undefined) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
          });
        }
        this.getDefaultMeetingMasterList();
      });
    }
  }

}

